<template>
  <jc-dialog ref="dialog" :show.sync="show"
             btn-confirm-text='<i class="fal fa-unlink"></i> Bỏ lưu kho'
             title="Xác nhận bỏ lưu kho"
             type="red"
             @onConfirm="onDelete()"
  >
    <table class="table table-hover">
      <tr>
        <th>#</th>
        <td>{{ model.index }}</td>
      </tr>
      <tr>
        <th>Mã shop</th>
        <td>{{ model.shopCode }}</td>
      </tr>
      <tr>
        <th>Tên shop</th>
        <td>{{ model.shopName }}</td>
      </tr>
      <tr>
        <th>Tên kho</th>
        <td>{{ model.name }}</td>
      </tr>
    </table>
  </jc-dialog>
</template>

<script>
import dialogMixins from "@/mixins/dialogMixins";

export default {
  name: "WarehouseConfirmDelete",
  mixins: [dialogMixins],
  data() {
    return {
      model: {},
      show: false
    }
  },
  methods: {
    open(item) {
      if (item) {
        this.show = true;
        this.model = item;
      } else {
        this.$warning('Chưa chọn cấu hình kho bỏ lưu kho')
      }
    },
    onDelete() {
      this.$showLoader();
      const vue = this;
      let data = vue.model;
      vue.$http
         .delete(
             "/admin-service/v1.0/station/warehouse-shop?shop_order=" + data.shopOrder,
             {
               data: {
                 "station_id": data.stationId,
                 "first_address": ''
               },
             }
         )
         .then(successRes => {
           this.close();
           this.$success();
           this.$stopLoader();

           this.$emit("success", successRes);
         }, errorRes => {
           this.errorNotify(errorRes);
           this.$stopLoader();
           this.$emit("error", errorRes);
         });
    }
  }
}
</script>

<style scoped>

</style>